import React from "react";

import {
  t,
  HEADING2,
  HEADING2_P1,
  HEADING2_P2,
  HEADING2_P3,
  HEADING2_P4,
  HEADING2_P5,
  HEADING2_P6,
  HEADING2_P7,
  HEADING2_P8,
} from "../../translations/AboutUs/SutpIts";

function AboutSutp() {
  return (
    <div style={{ padding: "12px 0px" }}>
      <div className="main-header">{t(HEADING2)}</div>
      <div>
        <p>{t(HEADING2_P1)}</p>
        <p>{t(HEADING2_P2)}</p>
        <p>{t(HEADING2_P3)}</p>
        <p>{t(HEADING2_P4)}</p>
        <p>{t(HEADING2_P5)}</p>
        <p>{t(HEADING2_P6)}</p>
        <p>{t(HEADING2_P7)}</p>
        <p>{t(HEADING2_P8)}</p>
      </div>
    </div>
  );
}

export default AboutSutp;
